import dva from 'dva';
import { Component } from 'react';
import createLoading from 'dva-loading';
import history from '@tmp/history';

let app = null;

export function _onCreate() {
  const plugins = require('umi/_runtimePlugin');
  const runtimeDva = plugins.mergeConfig('dva');
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    ...(window.g_useSSR ? { initialState: window.g_initialData } : {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach(plugin => {
    app.use(plugin);
  });
  
  app.model({ namespace: 'app', ...(require('/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/models/app.js').default) });
app.model({ namespace: 'customRule', ...(require('/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/models/customRule.js').default) });
app.model({ namespace: 'injected', ...(require('/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/models/injected.js').default) });
app.model({ namespace: 'organizationStructure', ...(require('/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/models/organizationStructure.js').default) });
app.model({ namespace: 'passwordConfig', ...(require('/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/models/passwordConfig.js').default) });
app.model({ namespace: 'users', ...(require('/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/models/users.js').default) });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
